// extracted by mini-css-extract-plugin
export default {"transportation":"serviceitem_transportation__R9hfe"};